export default {
    host: 'http://localhost:3000',
    apiHost: 'http://localhost:5000',
    S3Endpoint: 'https://ys-organizations.s3-ap-northeast-1.amazonaws.com/Mibao-Website'
}


// WEBPACK FOOTER //
// ./src/helpers/config.js